export enum AgentState {
	Ok = 'OK',
	Warning = 'WARNING',
	Error = 'ERROR',
	Maintenance = 'MAINTENANCE',
}
